module.exports = __webpack_public_path__ + "static/media/cover-3.c0d5f06d.png";